import { DICWindow } from '../typedefs/window';

declare var window: DICWindow;

export default function createMiddleware() {
    return (store: any) => (next: any) => (action: any) => {
        try {
            return next(action);
        } catch (err) {
            if (window.DIConv.Bugsnag) {
                const name = `${action.type} Error`;
                const metadata = { action, state: store.getState() };
                window.DIConv.Bugsnag.notifyException(err, name, metadata, 'error');
            }

            throw err;
        }
    };
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/store/ErrorReporterMiddleware.ts